import React from "react";
import ImageWithTooltip from "./ImageWithTooltip";
import { BsTelephone } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";

const PersonCard = ({ imageSrc, name, title, phone, email }) => {
  return (
    <div className="w-[260px]  overflow-hidden p-2">
      <div className="flex flex-col gap-1">
        <ImageWithTooltip
          className="w-auto h-[200px] rounded-lg m-auto"
          src={imageSrc}
          alt={name}
        />
        <h5 className="text-sm font-bold text-white m-auto bg-[#272974] p-2 rounded-md w-full text-center">
          {name}
        </h5>
        <p className="text-sm text-gray-500 m-auto text-center h-14 line-clamp-3 whitespace-pre-wrap">
          {title}
        </p>
        <div>
          <div className="flex items-center justify-center text-gray-700">
            <BsTelephone />
            <p>{phone}</p>
          </div>
          <div className="flex items-center justify-center text-gray-700">
            <AiOutlineMail />
            <p>{email}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonCard;
